<p
    [id]="paragraphId"
    class="ellipsis vertical-ellipsis"
    [pTooltip]="pTooltip"
    [tooltipPosition]="tooltipPosition"
    [style.-webkit-line-clamp]="ellipsisNumberOfRows"
    [showDelay]="tooltipDelayTime"
    [tabindex]="isElementFocusable ? 0 : -1"
    #contentTemplate
    tooltipFocusHandler
    (mouseenter)="shouldShowTooltip()">
    <ng-content></ng-content>
</p>
